/** @prettier */
import { connect } from 'react-redux';

import { subscribeToEvent, unsubscribeToEvent } from '@xanadu/ui-shared/modules/event/actions';

import RelatedEvent from '../../../../components/SingleEventPage/RelatedEvents/components/RelatedEvent';

const mapDispatchToProps = {
  subscribeToEvent,
  unsubscribeToEvent,
};

export default connect(null, mapDispatchToProps)(RelatedEvent);
